import React from 'react';

const QuickActionRow = ({icon: Icon, title, description, primary, actions = [],titleColor = "text-slate-800",
  buttonColor = "bg-blue-600 hover:bg-blue-700 text-white" }) => {
return (
    <li className="items-start gap-4 py-4">
      {/* Left-side primary action */}
      {/* Icon + content */}
      <div className="flex-1 flex items-start gap-3">
        <div className="rounded-lg border bg-gray-50 p-2">
          <Icon className="h-4 w-4 text-gray-700" />
        </div>
        <div className="min-w-0">
          <h3 className={`font-medium ${titleColor}`}>{title}</h3>
          {description && (
            <p className="text-sm text-slate-500">{description}</p>
          )}
        </div>
      </div>
        <button
        onClick={primary?.onClick}
         className={`px-4 ml-10 py-2 mt-2 rounded-md text-sm font-medium ${buttonColor}`}
      >
        {primary?.label || 'Start'}
      </button>

    </li>
  )
  }

export default QuickActionRow;
